import { render, staticRenderFns } from "./AnalyzesPendingToBeMailed.vue?vue&type=template&id=4db9c6b0&"
import script from "./AnalyzesPendingToBeMailed.vue?vue&type=script&lang=ts&"
export * from "./AnalyzesPendingToBeMailed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports